import { APPLICATIONS, getApplicationAccessLink } from '~/components/ApplicationUrls';
import { STENCIL_PREFIX_CLS } from '@mindtickle/styles/lib/classNames';

export const DEFAULT_HELP_SITE_URL: string = '/help-center-url';
export const WISTIA_IFRAME_URL = (id: string): string =>
  `https://fast.wistia.net/embed/iframe/${id}`;

export const APP_NAME: string = 'LearnerHeader';
export const STREAM_NAME: string = 'readiness';
export const PROJECT_TYPE: string = 'learner';

export const URLS: {
  PROFILE: string;
  LEARNER_HOME: string;
  HELP_SITE: string;
  TEAM_REPORT_URL: () => string;
  MY_RI_SCORECARD_URL: string;
  PROFILE_URL: (id: string) => string;
  PARTICIPANTS: string;
  ANALYTICS: string;
  REVQ: string;
  COMMAND_CENTER: string;
} = {
  PROFILE: getApplicationAccessLink(APPLICATIONS.PROFILE),
  LEARNER_HOME: getApplicationAccessLink(APPLICATIONS.LEARNER_READINESS_DASHBOARD),
  HELP_SITE: DEFAULT_HELP_SITE_URL,
  TEAM_REPORT_URL: (): string =>
    `${getApplicationAccessLink(APPLICATIONS.ANALYTICS)}/dashboard/manager-home`,
  MY_RI_SCORECARD_URL: `${getApplicationAccessLink(APPLICATIONS.ANALYTICS)}/my-scorecard`,
  PROFILE_URL: (id: string): string => `#/participants/${id}`,
  PARTICIPANTS: `#/participants`,
  ANALYTICS: getApplicationAccessLink(APPLICATIONS.ANALYTICS),
  REVQ: getApplicationAccessLink(APPLICATIONS.REVQ),
  COMMAND_CENTER: getApplicationAccessLink(APPLICATIONS.COMMAND_CENTER),
};

export const MENU_KEYS: {
  HELP_SITE: string;
  GET_SUPPORT: string;
  LOGOUT: string;
  PRIVACY_POLICY: string;
  TUTORIAL: string;
  PROFILE: string;
} = {
  HELP_SITE: 'HELP_SITE',
  GET_SUPPORT: 'GET_SUPPORT',
  LOGOUT: 'LOGOUT',
  PRIVACY_POLICY: 'PRIVACY_POLICY',
  TUTORIAL: 'TUTORIAL',
  PROFILE: 'PROFILE',
};

export const REMOTE_FILE: string = `${process.env.FEDERATION_REMOTE_FILE_NAME}.js`;

export const TUT_MODAL_NAMES: {
  DASHBOARD: string;
  GLOBAL_SEARCH: string;
} = {
  DASHBOARD: 'dashboard_tutorial',
  GLOBAL_SEARCH: 'global_search_tutorial',
};

export const TUTORIAL_I_FRAME_ID: {
  [key: string]: string;
} = {
  [TUT_MODAL_NAMES.DASHBOARD]: 'pnxfrldpov',
  [TUT_MODAL_NAMES.GLOBAL_SEARCH]: 'uo79wefgwp',
};

export const THEME: { prefixCls: string } = { prefixCls: STENCIL_PREFIX_CLS };

export const KEY: {
  KEY_1: string;
  ENTER: string;
} = {
  KEY_1: '1',
  ENTER: 'Enter',
};

export const searchBarExcludePaths: string[] = [
  getApplicationAccessLink(APPLICATIONS.ANALYTICS),
  '/callai',
  '/callai/integration',
];

export const searchBarExcludePathsReorg: string[] = ['/callai', '/callai/integration'];

export const MANAGE_SUBORDINATES: string = 'MANAGE_SUBORDINATES';

export const ASSISTANT_USER_QUERY: string = `query getAssistantForAUser {
  user {
    getUser {
      assistant(assistantFilter : {assistantType: SELLER_COPILOT}) {
        id
        name
        type
      }
    }
  }
}`;

export const MODULE_URLS: {
  coaching: string;
  reinforcement: string;
  checklist: string;
} = {
  coaching: '/ui/coaching',
  reinforcement: '/ui/reinforcement',
  checklist: '/ui/checklist',
};

export const LEARNER_HEADER_SECTIONS_COUNT = 3;

export const PRIVACY_POLICY_URL = 'http://www.mindtickle.com/privacy-policy';

export const GLOBAL_SEARCH_BE_CONFIG = {
  boundaryOn: 'globalSearchSuspense',
};
